// Interface language. The server sets it from the APP_LANGUAGE environment variable by adding
// <meta name="app-language"> to the page, so one build can be hosted in any language;
// REACT_APP_LANGUAGE does the same for the development server.
// Translations are keyed by the English text, so a missing translation shows the English.
import fr from './locales/fr.json';

const LOCALES = { fr };

function detectLanguage() {
  const meta = typeof document !== 'undefined' ? document.querySelector('meta[name="app-language"]') : null;
  return (meta?.getAttribute('content') || process.env.REACT_APP_LANGUAGE || 'en').toLowerCase();
}

export const LANGUAGE = detectLanguage();
const dictionary = LOCALES[LANGUAGE] || {};

// t('Delete {name}?', { name }) translates the text, then fills in the {placeholders}
export function t(text, values) {
  if (typeof text !== 'string') return text;
  const translated = dictionary[text] || text;
  if (!values) return translated;
  return translated.replace(/\{(\w+)\}/g, (match, key) => (key in values ? String(values[key]) : match));
}
